module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/before-using-vux-29.vue");


//////////////////
// WEBPACK FOOTER
// ./en/about/before-using-vux.md
// module id = 475
// module chunks = 467